<template>
  <div
    v-if="!tawkStarted && !verificationFailed"
    class="fixed right-0 bottom-0 mr-3 mb-3 z-5"
    style="width: min(300px, calc(100vw - 2rem))"
  >
    <TurnstileWidget
      v-model="turnstileToken"
      action="tawk_chat"
      appearance="interaction-only"
    />
  </div>
</template>

<script setup>
const { $startTawk } = useNuxtApp()
const turnstileToken = ref('')
const isVerifying = ref(false)
const verificationFailed = ref(false)
const tawkStarted = ref(false)

watch(turnstileToken, async (token) => {
  if (!token || isVerifying.value || tawkStarted.value) return

  isVerifying.value = true
  verificationFailed.value = false
  let turnstileVerified = false

  try {
    await $fetch('/api/tawk/verify', {
      method: 'POST',
      body: {
        turnstile_token: token,
      },
    })
    turnstileVerified = true
    await $startTawk()
    tawkStarted.value = true
  } catch (error) {
    console.warn(
      turnstileVerified
        ? 'Tawk.to failed to start after security verification'
        : 'Tawk.to security verification failed',
      error,
    )
    verificationFailed.value = true
  } finally {
    isVerifying.value = false
  }
})
</script>
